import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import desktop_logo from '../assets/icons/logo_desktop.svg';
import '../styles/header.css';

const Header = () => {
    const location = useLocation();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 450);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const tabs = [
        { name: 'Home', path: '/' },
        { name: 'Studies', path: '/studies' },
        { name: 'Technology', path: '/technology' },
        { name: 'Contact', path: '/contact' }
    ];

    useEffect(() => {
        const handleResize = () => {
            const isNowMobile = window.innerWidth < 450;
            setIsMobile(isNowMobile);
            if (!isNowMobile) {
                setIsMenuOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    return (
        <header className="header">
            {isMobile ? (
                <>
                    <div className="header-mobile">
                        <img src={desktop_logo} alt="Logo" className="header-logo-mobile" />
                        <div className="burger-menu-icon" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                            <div className="bar"></div>
                            <div className="bar"></div>
                            <div className="bar"></div>
                        </div>
                    </div>

                    {isMenuOpen && (
                        <div className="burger-dropdown">
                            <div className="burger-dropdown-header">
                                <img src={desktop_logo} alt="Logo" className="dropdown-logo-centered" />
                                <button className="close-button" onClick={() => setIsMenuOpen(false)}>
                                    &#10005;
                                </button>
                            </div>

                            <div className="burger-dropdown-links">
                                {tabs.map((tab) => (
                                    <Link
                                        key={tab.name}
                                        to={tab.path}
                                        className={`dropdown-link ${location.pathname === tab.path ? 'active' : ''}`}
                                        onClick={() => setIsMenuOpen(false)}
                                    >
                                        {tab.name}
                                    </Link>
                                ))}
                            </div>
                        </div>
                    )}

                </>
            ) : (
                <>
                    {tabs.slice(0, 2).map((tab) => (
                        <Link
                            key={tab.name}
                            to={tab.path}
                            className={`header-tab ${location.pathname === tab.path ? 'active' : ''}`}
                        >
                            {tab.name}
                        </Link>
                    ))}

                    <img src={desktop_logo} alt="Logo" className="header-logo" />

                    {tabs.slice(2).map((tab) => (
                        <Link
                            key={tab.name}
                            to={tab.path}
                            className={`header-tab ${location.pathname === tab.path ? 'active' : ''}`}
                        >
                            {tab.name}
                        </Link>
                    ))}
                </>
            )}
        </header>
    );
};

export default Header;
